import template from './employee_fields_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class EmployeeFieldsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeeFieldsHelpPage
{
	constructor (bindings) {
		this.viewModel = new EmployeeFieldsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

// Register the dialog
export default {
	name: 'EmployeeFieldsHelp',
	dialog_class: EmployeeFieldsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_fields_help',
	provider: 'ps'
};
